module.exports = __webpack_public_path__ + "media/cafecito.aa3d42bd.mp4";